import React, { useState } from 'react';
import api from '../utils/api';

export default function DeliveryVerify() {
  const [phone, setPhone]       = useState('');
  const [otpMap, setOtpMap]     = useState({});
  const [order_type, setOrderType] = useState('animal');
  const [loading, setLoading]   = useState(false);
  const [orders, setOrders]     = useState(null);
  const [result, setResult]     = useState(null);
  const [searched, setSearched] = useState(false);

  const handleFindOrders = async () => {
    if (!phone || phone.length !== 10) { alert('Enter valid 10-digit phone'); return; }
    setLoading(true);
    setOrders(null);
    setResult(null);
    setSearched(false);
    try {
      const { data } = await api.get(`/api/delivery/my-orders?phone=${phone}&order_type=${order_type}`);
      setOrders(data);
      setSearched(true);
    } catch (err) {
      alert(err.response?.data?.error || 'No orders found');
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (orderId) => {
    const otp = otpMap[orderId] || '';
    if (!otp || otp.length !== 6) { alert('Enter 6-digit OTP'); return; }
    setLoading(true);
    setResult(null);
    try {
      const { data } = await api.post('/api/delivery/verify-otp', { otp, phone, order_type });
      setResult({ success: true, message: data.message, orderId });
      const { data: updated } = await api.get(`/api/delivery/my-orders?phone=${phone}&order_type=${order_type}`);
      setOrders(updated);
    } catch (err) {
      setResult({ success: false, message: err.response?.data?.error || 'Verification failed', orderId });
    } finally {
      setLoading(false);
    }
  };

  const handleMarkCash = async (orderId) => {
    try {
      await api.patch('/api/delivery/mark-cash-received', { order_id: orderId, order_type });
      const { data: updated } = await api.get(`/api/delivery/my-orders?phone=${phone}&order_type=${order_type}`);
      setOrders(updated);
    } catch { alert('Failed'); }
  };

  const pending   = orders ? orders.filter(o => !o.otp_verified) : [];
  const completed = orders ? orders.filter(o => o.otp_verified)  : [];
  const totalAmt  = completed.reduce((s, o) => s + Number(o.amount || 0), 0);

  return (
    <div style={{ minHeight: '100vh', background: '#fcfffe', fontFamily: "'DM Sans', sans-serif", color: '#e8f0eb' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');
        * { box-sizing: border-box; }
        .dv-input { width:100%; background: #131a15; border: 1px solid #2a3d2e; border-radius: 12px; color: #e8f0eb; font-family: 'DM Sans',sans-serif; font-size: 15px; padding: 13px 16px; outline: none; transition: border 0.2s; }
        .dv-input:focus { border-color: #3dba6f; }
        .dv-input::placeholder { color: #3d5445; }
        .dv-btn-primary { width:100%; padding:14px; border-radius:12px; background: #3dba6f; border:none; color:#061008; font-family:'DM Sans',sans-serif; font-size:15px; font-weight:600; cursor:pointer; transition: all 0.2s; letter-spacing:0.01em; }
        .dv-btn-primary:hover { background:#45d47d; }
        .dv-btn-primary:disabled { background:#1e3324; color:#3d5445; cursor:not-allowed; }
        .dv-btn-ghost { width:100%; padding:12px; border-radius:12px; background:transparent; border:1px solid #2a3d2e; color:#8ab89a; font-family:'DM Sans',sans-serif; font-size:14px; font-weight:500; cursor:pointer; transition: all 0.2s; }
        .dv-btn-ghost:hover { border-color:#3dba6f; color:#3dba6f; background:#0e1f12; }
        .dv-card { background:#111a13; border:1px solid #1e2f20; border-radius:16px; padding:20px; margin-bottom:14px; }
        .dv-otp { width:100%; background:#0a0f0d; border:1px solid #2a3d2e; border-radius:12px; color:#3dba6f; font-family:'DM Mono',monospace; font-size:28px; letter-spacing:12px; text-align:center; padding:14px 16px; outline:none; transition: border 0.2s; }
        .dv-otp:focus { border-color:#3dba6f; box-shadow: 0 0 0 3px rgba(61,186,111,0.1); }
        .dv-tab { flex:1; padding:10px 8px; border-radius:10px; border:1px solid #1e2f20; background:transparent; color:#3d5445; font-family:'DM Sans',sans-serif; font-size:13px; font-weight:500; cursor:pointer; transition:all 0.2s; text-align:center; }
        .dv-tab.active { background:#0e1f12; border-color:#3dba6f; color:#3dba6f; }
        .dv-stat { background:#0e1a10; border:1px solid #1e2f20; border-radius:12px; padding:16px; flex:1; }
        .pulse { animation: pulse 2s infinite; }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.5} }
        .slide-in { animation: slideIn 0.3s ease; }
        @keyframes slideIn { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
      `}</style>

      {/* Top bar */}
      <div style={{ background:'#0d1115', borderBottom:'1px solid #1a2e1c', padding:'16px 20px', display:'flex', alignItems:'center', gap:12 }}>
        <div style={{ width:38, height:38, borderRadius:10, background:'#0e1f12', border:'1px solid #2a3d2e', display:'flex', alignItems:'center', justifyContent:'center' }}>
          <span className="material-symbols-outlined" style={{ color:'#3dba6f', fontSize:20 }}>local_shipping</span>
        </div>
        <div>
          <div style={{ fontSize:15, fontWeight:600, color:'#e8f0eb', lineHeight:1 }}>Delivery Portal</div>
          <div style={{ fontSize:11, color:'#3d5445', marginTop:3 }}>Elite Goats & Meats</div>
        </div>
        {searched && orders && (
          <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:6, background:'#0e1f12', border:'1px solid #2a3d2e', borderRadius:99, padding:'4px 12px' }}>
            <span style={{ width:7, height:7, borderRadius:'50%', background:'#3dba6f', display:'inline-block' }} className="pulse" />
            <span style={{ fontSize:12, color:'#8ab89a' }}>+91 {phone}</span>
          </div>
        )}
      </div>

      <div style={{ maxWidth:520, margin:'0 auto', padding:'20px 16px' }}>

        {/* Stats row — only after search */}
        {searched && orders && (
          <div className="slide-in" style={{ display:'flex', gap:10, marginBottom:20 }}>
            <div className="dv-stat">
              <div style={{ fontSize:11, color:'#3d5445', fontWeight:500, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:6 }}>Pending</div>
              <div style={{ fontSize:28, fontWeight:600, color: pending.length > 0 ? '#f5a623' : '#3d5445' }}>{pending.length}</div>
              <div style={{ fontSize:11, color:'#3d5445', marginTop:2 }}>deliveries</div>
            </div>
            <div className="dv-stat">
              <div style={{ fontSize:11, color:'#3d5445', fontWeight:500, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:6 }}>Completed</div>
              <div style={{ fontSize:28, fontWeight:600, color:'#3dba6f' }}>{completed.length}</div>
              <div style={{ fontSize:11, color:'#3d5445', marginTop:2 }}>today</div>
            </div>
            <div className="dv-stat">
              <div style={{ fontSize:11, color:'#3d5445', fontWeight:500, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:6 }}>Collected</div>
              <div style={{ fontSize:20, fontWeight:600, color:'#e8f0eb', marginTop:4 }}>₹{totalAmt.toLocaleString('en-IN')}</div>
              <div style={{ fontSize:11, color:'#3d5445', marginTop:2 }}>total</div>
            </div>
          </div>
        )}

        {/* Search panel */}
        <div className="dv-card" style={{ marginBottom:16 }}>
          <div style={{ display:'flex', gap:8, marginBottom:14 }}>
            <button className={`dv-tab ${order_type==='animal'?'active':''}`}
              onClick={() => { setOrderType('animal'); setOrders(null); setSearched(false); }}>
              <span className="material-symbols-outlined" style={{ fontSize:16, verticalAlign:'middle', marginRight:4 }}>pets</span>
              Livestock
            </button>
            <button className={`dv-tab ${order_type==='shop'?'active':''}`}
              onClick={() => { setOrderType('shop'); setOrders(null); setSearched(false); }}>
              <span className="material-symbols-outlined" style={{ fontSize:16, verticalAlign:'middle', marginRight:4 }}>storefront</span>
              Meat products
            </button>
          </div>

          <div style={{ display:'flex', gap:8 }}>
            <div style={{ position:'relative', flex:1 }}>
              <span style={{ position:'absolute', left:14, top:'50%', transform:'translateY(-50%)', fontSize:13, color:'#3d5445', fontFamily:"'DM Mono',monospace", fontWeight:500 }}>+91</span>
              <input
                className="dv-input"
                style={{ paddingLeft:48 }}
                type="tel" maxLength={10} value={phone}
                onChange={e => { setPhone(e.target.value.replace(/\D/g,'').slice(0,10)); setOrders(null); setSearched(false); }}
                placeholder="9876543210"
                onKeyDown={e => e.key === 'Enter' && handleFindOrders()}
              />
            </div>
            <button onClick={handleFindOrders} disabled={loading || phone.length !== 10}
              style={{ padding:'13px 20px', borderRadius:12, background: phone.length===10 ? '#3dba6f':'#1e3324', border:'none', color: phone.length===10 ? '#061008':'#3d5445', fontFamily:"'DM Sans',sans-serif", fontSize:14, fontWeight:600, cursor: phone.length===10 ? 'pointer':'not-allowed', transition:'all 0.2s', whiteSpace:'nowrap' }}>
              {loading ? '...' : 'Find'}
            </button>
          </div>
        </div>

        {/* Empty state */}
        {searched && orders && orders.length === 0 && (
          <div className="slide-in" style={{ textAlign:'center', padding:'40px 20px', color:'#3d5445' }}>
            <span className="material-symbols-outlined" style={{ fontSize:48, display:'block', marginBottom:12, color:'#1e2f20' }}>inbox</span>
            <div style={{ fontSize:15, fontWeight:500, color:'#3d5445' }}>No deliveries assigned</div>
            <div style={{ fontSize:13, marginTop:4 }}>for +91 {phone}</div>
          </div>
        )}

        {/* Pending deliveries */}
        {pending.length > 0 && (
          <>
            <div style={{ fontSize:11, fontWeight:600, color:'#3d5445', textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:10 }}>
              Pending deliveries
            </div>
            {pending.map(o => (
              <div key={o.id} className="dv-card slide-in" style={{ borderColor:'#2a3d1a' }}>
                {/* Header */}
                <div style={{ display:'flex', alignItems:'flex-start', gap:12, marginBottom:14 }}>
                  {o.image_url
                    ? <img src={o.image_url} style={{ width:52, height:52, borderRadius:10, objectFit:'cover', flexShrink:0, border:'1px solid #1e2f20' }} alt="" />
                    : <div style={{ width:52, height:52, borderRadius:10, background:'#0e1a10', border:'1px solid #1e2f20', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                        <span className="material-symbols-outlined" style={{ color:'#2a3d2e', fontSize:24 }}>pets</span>
                      </div>
                  }
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:15, fontWeight:600, color:'#e8f0eb' }}>{o.animal_name || o.product_name}</div>
                    <div style={{ fontSize:12, color:'#3d5445', fontFamily:"'DM Mono',monospace", marginTop:2 }}>#{o.id}</div>
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:6 }}>
                      <span style={{ fontSize:15, fontWeight:600, color:'#3dba6f' }}>₹{Number(o.amount).toLocaleString('en-IN')}</span>
                      {o.payment_method === 'cod' && (
                        <span style={{ fontSize:10, background:'#2a1f08', border:'1px solid #5a3d10', color:'#f5a623', borderRadius:99, padding:'2px 8px', fontWeight:500 }}>COD</span>
                      )}
                    </div>
                  </div>
                  <span style={{ fontSize:11, background:'#1a2e0d', border:'1px solid #2a4d18', color:'#6db85c', borderRadius:99, padding:'4px 10px', fontWeight:500, whiteSpace:'nowrap' }}>Out for delivery</span>
                </div>

                {/* Delivery info */}
                <div style={{ background:'#0a0f0d', borderRadius:10, border:'1px solid #1a2a1c', padding:12, marginBottom:14 }}>
                  <div style={{ fontSize:10, color:'#3d5445', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:8 }}>Deliver to</div>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6 }}>
                    <span className="material-symbols-outlined" style={{ fontSize:16, color:'#3d5445' }}>person</span>
                    <span style={{ fontSize:14, fontWeight:500, color:'#e8f0eb' }}>{o.buyer_name || '—'}</span>
                  </div>
                  {o.buyer_phone && (
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6 }}>
                      <span className="material-symbols-outlined" style={{ fontSize:16, color:'#3d5445' }}>call</span>
                      <a href={`tel:${o.buyer_phone}`} style={{ fontSize:14, color:'#3dba6f', fontWeight:500, textDecoration:'none' }}>{o.buyer_phone}</a>
                    </div>
                  )}
                  {o.delivery_address && (
                    <div style={{ display:'flex', alignItems:'flex-start', gap:8 }}>
                      <span className="material-symbols-outlined" style={{ fontSize:16, color:'#3d5445', marginTop:1 }}>location_on</span>
                      <div>
                        <div style={{ fontSize:13, color:'#8ab89a', lineHeight:1.4 }}>{o.delivery_address}</div>
                        <a href={`https://maps.google.com/?q=${encodeURIComponent(o.delivery_address)}`} target="_blank" rel="noreferrer"
                          style={{ fontSize:12, color:'#3dba6f', display:'inline-flex', alignItems:'center', gap:3, marginTop:4, textDecoration:'none' }}>
                          <span className="material-symbols-outlined" style={{ fontSize:14 }}>open_in_new</span>
                          Open in maps
                        </a>
                      </div>
                    </div>
                  )}
                </div>

                {/* OTP */}
                <div style={{ marginBottom:10 }}>
                  <div style={{ fontSize:11, color:'#3d5445', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:8 }}>
                    Enter customer OTP
                  </div>
                  <input
                    className="dv-otp"
                    type="tel" maxLength={6}
                    value={otpMap[o.id] || ''}
                    onChange={e => setOtpMap(prev => ({ ...prev, [o.id]: e.target.value.replace(/\D/g,'').slice(0,6) }))}
                    placeholder="——————"
                  />
                </div>

                {result && result.orderId === o.id && (
                  <div style={{ borderRadius:10, padding:'10px 14px', marginBottom:10, display:'flex', alignItems:'center', gap:8, fontSize:13, fontWeight:500,
                    background: result.success ? '#0b1f0e' : '#1f0b0b',
                    border: `1px solid ${result.success ? '#2a4d18' : '#4d1818'}`,
                    color: result.success ? '#6db85c' : '#e05c5c' }}>
                    <span className="material-symbols-outlined" style={{ fontSize:18 }}>{result.success ? 'check_circle' : 'error'}</span>
                    {result.message}
                  </div>
                )}

                <button className="dv-btn-primary" onClick={() => handleVerify(o.id)}
                  disabled={loading || !otpMap[o.id] || otpMap[o.id].length < 6}>
                  {loading ? 'Verifying...' : 'Confirm delivery'}
                </button>
              </div>
            ))}
          </>
        )}

        {/* Completed */}
        {completed.length > 0 && (
          <>
            <div style={{ fontSize:11, fontWeight:600, color:'#3d5445', textTransform:'uppercase', letterSpacing:'0.1em', margin:'20px 0 10px' }}>
              Completed
            </div>
            {completed.map(o => (
              <div key={o.id} className="dv-card slide-in" style={{ opacity:0.85 }}>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  {o.image_url
                    ? <img src={o.image_url} style={{ width:44, height:44, borderRadius:8, objectFit:'cover', flexShrink:0, filter:'grayscale(0.3)' }} alt="" />
                    : <div style={{ width:44, height:44, borderRadius:8, background:'#0a0f0d', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                        <span className="material-symbols-outlined" style={{ color:'#1e2f20', fontSize:20 }}>pets</span>
                      </div>
                  }
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:14, fontWeight:500, color:'#8ab89a' }}>{o.animal_name || o.product_name}</div>
                    <div style={{ fontSize:12, color:'#3d5445' }}>#{o.id} · ₹{Number(o.amount).toLocaleString('en-IN')}</div>
                  </div>
                  <div style={{ display:'flex', alignItems:'center', gap:6, background:'#0b1f0e', border:'1px solid #2a4d18', borderRadius:99, padding:'4px 10px' }}>
                    <span className="material-symbols-outlined" style={{ fontSize:14, color:'#3dba6f' }}>check_circle</span>
                    <span style={{ fontSize:11, color:'#6db85c', fontWeight:500 }}>Delivered</span>
                  </div>
                </div>

                {o.payment_method === 'cod' && o.payment_status !== 'paid' && (
                  <button className="dv-btn-ghost" style={{ marginTop:12 }} onClick={() => handleMarkCash(o.id)}>
                    <span className="material-symbols-outlined" style={{ fontSize:16, verticalAlign:'middle', marginRight:4 }}>payments</span>
                    Mark cash received · ₹{Number(o.amount).toLocaleString('en-IN')}
                  </button>
                )}
                {o.payment_method === 'cod' && o.payment_status === 'paid' && (
                  <div style={{ marginTop:10, fontSize:12, color:'#3d5445', display:'flex', alignItems:'center', gap:6 }}>
                    <span className="material-symbols-outlined" style={{ fontSize:14, color:'#3dba6f' }}>payments</span>
                    Cash collected
                  </div>
                )}
              </div>
            ))}
          </>
        )}

      </div>
    </div>
  );
}